import CONSTANT from "@api/constant";
export default [{
  path: '/market',
  name: 'market',
  meta: {
    platformType: CONSTANT.SHOP
  },
  component: function component() {
    return import('@/layouts/market-layout');
  },
  children: [{
    path: 'shopRegister',
    name: 'm-shopRegister',
    component: function component() {
      return import('@/pagesMarket/login/shopRegister.vue');
    }
  }]
}, {
  path: '/market',
  name: 'market',
  meta: {
    platformType: CONSTANT.SUPPLIER
  },
  component: function component() {
    return import('@/layouts/market-layout/fullScreen.vue');
  },
  children: [{
    path: 'supplierLogin',
    name: 'm-supplierlogin',
    component: function component() {
      return import('@/pagesMarket/login/supplierLogin.vue');
    }
  }]
}];